import { WebStorageStateStore } from 'oidc-client-ts';
import { env } from './env';

// Zitadel-specific URN scopes that enrich the access-token JWT so the backend
// can verify everything locally — no /userinfo call needed.
const ZITADEL_SCOPES = [
  'openid',
  'profile',
  'email',
  'offline_access',
  'urn:zitadel:iam:user:resourceowner',          // adds org info claims
  'urn:zitadel:iam:user:metadata',               // adds user metadata (industry, bio, etc.)
  'urn:zitadel:iam:org:projects:roles',          // adds project role claims
  // Adds our project ID to the JWT's `aud` claim so the backend's
  // audience check passes.
  `urn:zitadel:iam:org:project:id:${env.oidc.projectId}:aud`,
  // Pins the login to our org: Login V2 shows Kaleideo branding from the
  // first screen and refuses users who are not members of this org.
  ...(env.oidc.orgId ? [`urn:zitadel:iam:org:id:${env.oidc.orgId}`] : []),
].join(' ');

export const oidcConfig = {
  authority: env.oidc.authority,
  client_id: env.oidc.clientId,
  redirect_uri: env.oidc.redirectUri,
  post_logout_redirect_uri: env.oidc.postLogoutUri,
  response_type: 'code',
  scope: ZITADEL_SCOPES,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  loadUserInfo: false,
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
